
import { Component, Input } from '@angular/core';
import { I18nModule, Product } from '@spartacus/core';
import { ProductMediaComponent } from '../../../product-media/product-media.component';
import { ProductComparatorFloatingService } from '../../core/product-comparator-floating.service';
import { PRODUCT_COMPARATOR_TYPE } from '../../../product-comparator/core/product-comparator.model';
import { TARGET_TYPE } from '../../../../../../core/models/link.model';
import { TooltipIconComponent } from "../../../../../../components/tooltip-icon/tooltip-icon.component";

@Component({
  selector: 'product-comparator-mini-card',
  standalone: true,
  imports: [ProductMediaComponent, I18nModule, TooltipIconComponent],
  templateUrl: './product-comparator-mini-card.component.html',
  styleUrl: './product-comparator-mini-card.component.scss',
})
export class ProductComparatorCardComponent {
  STORE = PRODUCT_COMPARATOR_TYPE.FLOATTING;
  TARGET_TYPE = TARGET_TYPE;

  @Input() product!: Product;

  constructor(private productComparatorService: ProductComparatorFloatingService) {}

  remove() {
    this.productComparatorService.removeProduct(this.product.code!);
  }
}
